import { addClass, findMany, hasClass, removeClass, find, on, off } from '../Libraries/helpers';

class FormLabel {
    constructor(container) {
        this.container = container;
        this.input = find('input', container) || find('textarea', container) || find('select', container);
        this.label = find('label', container);
        this.errors = find('.errors', container);
        this.alwaysShrink = this.input.nodeName === 'SELECT' || this.input.inputMode === 'numeric';

        this.setBindings();
        this.setState();
    }

    setBindings() {
        on('blur', () => this.onBlur(), this.input);
        on('keyup', () => this.onFirstKeyPress(), this.input)
        on('form-labels::refresh', () => this.setState());

        if (this.isEditable()) {
            on('focus', () => this.onFocus(), this.input);
        }
    }

    setState() {
        this.input.removeAttribute('placeholder');
        this.errors = find('.errors', this.container);

        this.handleVisibility();

        if (this.errors) {
            addClass(this.container, 'has-errors');
        }

        addClass(this.container, 'js-ready');
    }

    handleVisibility() {
        if (this.input.value || this.alwaysShrink) {
            addClass(this.container, 'small-label');
        } else {
            removeClass(this.container, 'small-label');
        }
    }

    isEditable() {
        return this.input.readOnly === false && this.input.disabled === false
    }

    onFirstKeyPress() {
        this.handleVisibility()
        off('keyup', this.onFirstKeyPress, this.input)
    }

    onFocus() {
        this.handleVisibility();
        addClass(this.container, 'is-focused');
        addClass(this.container, 'small-label');
    }

    onBlur() {
        this.handleVisibility();
        removeClass(this.container, 'is-focused');
    }
}

const init = function () {
    findMany('.js-form-label').map(el => {
        if (!hasClass(el, 'js-ready')) {
            new FormLabel(el)
        }
    });
};

on('form-labels::init', init);

init();
